/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import MuiTypography from '@material-ui/core/Typography';
import { capitalize } from '@material-ui/core/utils';
import clsx from 'clsx';
import React from 'react';
import useStyles from './styles';
import { OverridableTypography, Legacy_TypographyProps } from './types';

const Legacy_Typography = <C extends React.ElementType>(
    props: Legacy_TypographyProps<C, { component?: C }>,
): JSX.Element => {
    const { className, variant = 'inherit', fontSize = 'inherit', fontWeight = 'inherit', ...rest } = props;
    const fontSizeMapping = `fontSize${capitalize(fontSize)}`;
    const fontWeightMapping = `fontWeight${capitalize(fontWeight)}`;
    const classes = useStyles();

    return (
        <MuiTypography
            variant={variant}
            className={clsx(
                // @ts-ignore
                { [classes[fontSizeMapping]]: fontSize !== 'inherit' },
                // @ts-ignore
                { [classes[fontWeightMapping]]: fontWeight !== 'inherit' },
                className,
            )}
            {...rest}
        />
    );
};

export type { Legacy_TypographyProps };
export default Legacy_Typography as OverridableTypography;
